const TableHeaderCell = ({ className, children }) => {
  return (
    <p className={`${className} border-b border-b-[#EBECF1] p-2 px-3 font-semibold`}>{children}</p>
  )
}

export default TableHeaderCell
